<template>
  <sModal
    v-model="dialog"
    data-qa="confirm-agree-modal"
    :mask-closable="false"
    :title="$t('Application.ConfirmAgree')">
    <sButton
      slot="activator"
      data-qa="btn-tenders-to-agree"
      :disabled="loading == 'reject'"
      :loading="loading == 'resolve'"
      @click="open">
      {{ label ? label : $t('Tenders.ToAgree') }}
    </sButton>
    <SpilkaFormioMFOld
      v-if="dialog && formParams && formParams.formCode"
      ref="formioForm"
      class="ml-2"
      :disabled="!!loading"
      :form-params="formParams"
      :hide-submit="true"
      :key-draft="keyDraft"
      :show-alert="false"
      @formLoad="showTour"
      @initialized="loadForm = false"
      @submit-error="errorFormio"
      @submit-valid="agreeFormio"/>
    <v-row
      v-else
      no-gutters>
      <v-col>
        <v-card-actions class="px-0 py-0">
          <sForm
            ref="confirm-agreeing-form"
            :disabled="loading == 'resolve'"
            label-position="top"
            :model="{text}"
            :rules="rules">
            <sFormItem
              prop="text">
              <sInput
                clearable
                :max-length="1500"
                max-rows="20"
                :placeholder="$t('Tenders.ApprovalComment')"
                show-word-limit
                trim
                type="textarea"
                :value.sync="text"/>
            </sFormItem>
          </sForm>
        </v-card-actions>
      </v-col>
    </v-row>
    <div
      key="footer"
      slot="footer">
      <TenderEgreement
        v-if="!formParams"
        :acceptors="acceptors"
        :callback="agree"
        :loading="!!loading"
        :tender="tender"/>
      <sButton
        v-else
        data-qa="btn-send"
        :loading="loadForm || !!loading"
        @click="submitFormio">
        {{ $t('Tenders.ToAgree') }}
      </sButton>
      <sButton
        class="ml-2"
        data-qa="btn-dialog-template-second"
        :disabled="!!loading"
        icon-class="mr-2"
        type="text"
        @click="close">
        {{ $t('Common.Close') }}
      </sButton>
      <template
        v-if="keyDraft">
        <sButton
          data-qa="save-as-draft"
          icon="diskette"
          :loading="loadForm || !!loading"
          type="text"
          @click="saveDraft">
          {{ $t('Application.SaveAsDraft') }}
        </sButton>
      </template>
    </div>
  </sModal>
</template>
<script>
import SpilkaFormioMFOld from 'components/common/SpilkaFormioMFOld.vue'
import TenderEgreement from 'components/tenders/dialogs/TenderEgreement.vue'

import { storageMixin } from 'mixins'
import { eventBus } from '@/main'

export default {
  name: 'confirmTenderAgreement',
  mixins: [ storageMixin ],
  data() {
    const that = this
    return {
      dialog: false,
      text: '',
      loadForm: true,
      rules: {
        text: [
          {
            type: 'string',
            trigger: 'change',
            max: 1500,
            message: that.$t('Validate.maxLength', {number: 1500, type: that.$tc('Common.characters', 10) })
          }
        ]
      },
    }
  },
  props: {
    tender: Object,
    loading: [Boolean, String],
    acceptors: Array,
    formParams: {
      type: Object
    },
    callback: Function,
    /**
     * Название кнопки
     */
    label: {
      type: String
    }
  },
  methods: {
    async showTour() {
      this.$nextTick(async () => {
        await this.$_getPropFromDBStorage('confirmTenderAgreement_tour', false)
          .then(async (viewedTour) => {
            if (viewedTour || !this.keyDraft) { return }
            eventBus.$emit('startTour', 'confirmReject')
            await this.$_savePropToDBStorage('confirmTenderAgreement_tour', true, new Date().setDate(new Date().getDate() + 180))
          })
      })
    },
    saveDraft() {
      this.$refs.formioForm.saveDraft()
      this.$notice.info({
        title: this.$t('Application.DraftSaved'),
        duration: 10
      })
    },
    open() {
      this.dialog = true
    },
    close() {
      this.dialog = false
    },
    submitFormio() {
      this.$emit('update:loading', true)
      this.$refs.formioForm.submit()
    },
    errorFormio() {
      this.$emit('update:loading', false)
    },
    async agreeFormio(params) {
      await this.callback(null, true, params)
      this.close()
    },
    async agree() {
      this.$emit('update:loading', true)
      await this.$refs['confirm-agreeing-form'].validate()
      await this.callback(this.text, true)

      if (this.keyDraft) {
        await this.$_deletePropFromDBStorage(this.keyDraft)
        //await this.$_deletePropFromDBStorage(localKey.replace('confirmTenderAgreement-', 'rejectDialog-'))
      }
      this.close()
    },
  },
  computed: {
    keyDraft() {
      let result
      if (this.formParams?.formCode && this.formParams?.params?.length) {
        const tenderId = this.formParams.params.find(i => i.key === 'tenderId')?.value
        if (tenderId) { result = `confirmTenderAgreement-${tenderId}-${this.formParams.formCode}-v-${this.formParams.version}_draft` }
      }
      return result
    },
  },
  components: {
    TenderEgreement,
    SpilkaFormioMFOld
  }
}
</script>
